export default "__VITE_ASSET__B75pjiaY__$_#arrow-visit-btn__"